<div class="form-wrapper">
    <div class="form-card">
        <h2>Participant Interest Form</h2>

        <form [formGroup]="form" (ngSubmit)="submit()">

            <!-- Name -->
            <div class="form-group">
                <label>Full Name</label>
                <input type="text" formControlName="name" placeholder="Enter full name" />
                <small *ngIf="form.get('name')?.touched && form.get('name')?.invalid">
                    Name is required
                </small>
            </div>

            <!-- Mobile -->
            <div class="form-group">
                <label>Mobile Number</label>
                <input type="tel" formControlName="mobile" placeholder="Enter 10 digit mobile" />
                <small *ngIf="form.get('mobile')?.touched && form.get('mobile')?.invalid">
                    Enter valid 10 digit mobile number
                </small>
            </div>

            <!-- Interested For -->
            <div class="form-group">
                <label>Interested For ?</label>

                <div class="checkbox-grid">
                    <label *ngFor="let product of productList" class="checkbox-item">
                        <input type="checkbox" [value]="product.product_title" (change)="onCheckboxChange($event)" />
                        <span>{{ product.product_title }}</span>
                    </label>
                </div>

                <small *ngIf="form.get('interests')?.touched && form.get('interests')?.invalid">
                    Please select at least one option
                </small>
            </div>

            <!-- Other Details -->
            <div class="form-group">
                <label>Other Details</label>
                <textarea rows="4" formControlName="other" placeholder="Additional notes..."></textarea>
            </div>

            <!-- Submit -->
            <button type="submit" class="submit-btn">
                Submit
            </button>

        </form>
    </div>
</div>